import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

// Import translation files
import englishTranslation from "./locales/english/translation.json";
import hausaTranslation from "./locales/hausa/translation.json";

/**
 * i18n Configuration
 * Sets up internationalization for English and Hausa languages
 * 
 * What each does:
  - i18next - Translation engine
  - react-i18next - React integration
  - i18next-browser-languagedetector - Auto-detect user's language
  - i18next-http-backend - Load translation files
 */

// Define resources (translations)
const resources = {
  en: {
    translation: englishTranslation,
  },
  ha: {
    translation: hausaTranslation,
  },
};

i18n
  // Detect user's language preference
  .use(LanguageDetector)
  // Pass the i18n instance to react-i18next
  .use(initReactI18next)
  // Initialize i18next
  .init({
    resources,
    // Fallback language if detected language not available
    fallbackLng: "en",
    // Debug mode (set to false in production)
    debug: false,
    // Namespace configuration
    ns: ["translation"],
    defaultNS: "translation",
    // Interpolation configuration
    interpolation: {
      // React already handles XSS
      escapeValue: false,
    },
    // Language detector options
    detection: {
      order: ["localStorage", "navigator", "htmlTag"],
      caches: ["localStorage"],
    },
  });

export default i18n;
